// Occupancy SSE deliberately omits equal-state receipts and price/site-only activity.
// Read only the visible open detail while live is enabled; never synthesize receipt times.
export function startDetailRefresh(read, {shouldRead, every = 60000, schedule = setInterval, cancel = clearInterval} = {}) {
  let pending = false;
  const timer = schedule(async () => {
    if (pending || !shouldRead()) return;
    pending = true;
    try { await read(); } finally { pending = false; }
  }, every);
  return () => cancel(timer);
}
